// extracted by mini-css-extract-plugin
module.exports = {"anchor":"Anchor_anchor__wmBmO","anchor__icons":"Anchor_anchor__icons__J03YS","anchor--active":"Anchor_anchor--active__RiCct"};